import { NgModule } from '@angular/core';
import { I18nModule, TranslationService } from '@p2p/i18n';

const SCOPES = ['common', 'payment'];

@NgModule({
    imports: [I18nModule]
})
export class PaymentFeatureSwitchingI18nModule {
    constructor(private readonly translationService: TranslationService) {
        this.setTranslations();
    }

    private async setTranslations(): Promise<void> {
        await this.translationService.setTranslations(SCOPES);
    }
}
